import React from 'react'
import { Row, Col, Button } from 'antd'
import { IconHelper } from '../../helpers'
import { translate } from 'react-i18next'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

const Announcement = ({ setIsEdit, t }) => {
    const { IconEdit } = IconHelper
    const announcement = useSelector(state => state.lobby.announcement)
    return (
        <>
            <div className="lobby-announcement">
                <div className="announcement-header">
                    <div>{t("lobby_announcement")}</div>
                    <div>
                        <Button className="btn-edit-vroom" onClick={() => setIsEdit(true)}>
                            <IconEdit width={15} style={{ marginRight: '5px' }} />
                            {t("lobby_edit")}
                        </Button>
                    </div>
                </div>
                <div className="announcement-detail">
                    <Row>
                        <Col span={24}>
                            <p className="announcement-content">
                                {!isEmpty(announcement)
                                    ? announcement
                                    : <label style={{ color: '#bfbfbf' }}>
                                        {t("lobby_announcement_placeholder")}
                                    </label>}
                            </p>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    )
}

export default translate()(Announcement)